import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const HelpCircleIcon: FC<SVGComponentProps> = ({
  width = 16,
  height = 16,
  stroke = '#1e293b',
  fill = '#fff'
}) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#a)">
        <path
          d="M6.06 6a2 2 0 0 1 3.887.667c0 1.334-2 2-2 2m.054 2.667h.006m6.66-3.333A6.667 6.667 0 1 1 1.334 8a6.667 6.667 0 0 1 13.333 0"
          stroke={stroke}
          strokeWidth={1.667}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill={fill} d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { HelpCircleIcon };
